interface TourMarker {
  cost?: number;
  currencyCode?: string;
}

// A tour is quoted once, not per night, so there is nothing to choose between the way a hotel rate has
// nightly and total forms. The catalogue price is indicative — the exact one comes with availability —
// which is why it is shown rounded on a pin.
const getTourRateToDisplay = (marker: TourMarker): number => Math.round(marker?.cost || 0);

export default getTourRateToDisplay;
